var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("textarea", {
      staticClass: "rp-input rp-textarea is-small",
      class: { "is-danger": _vm.status },
      attrs: {
        placeholder: _vm.inputData.placeholder,
        maxlength: _vm.inputData.maxlength
      },
      domProps: { value: _vm.value },
      on: {
        blur: function($event) {
          return _vm.validateInput()
        },
        input: function($event) {
          return _vm.updateValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _vm.status === true
      ? _c("div", { staticClass: "validation-text" }, [
          _vm._v("\n    " + _vm._s(_vm.t.pleaseInsertText) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f5e3845", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5e3845","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/form/TextareaInput.vue
// module id = null
// module chunks = 